module.exports = __webpack_public_path__ + "static/media/mixer1.dfde8cf1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/mixer1.jpeg
// module id = 1193
// module chunks = 0